import { Button } from "src/components/button/Button"
import InvestmentInput from "src/components/investment-input/InvestmentInput"
import { Heading } from "src/utils"
import cn from "classnames"
import s from "./FirstMiddleStep.module.scss"
import { StartInvestmentTab } from "../../../modules/investment-module/InvestmentModule"
import InvestmentTab from "src/components/investment-tab/InvestmentTab"
import { useState } from "react"
import React from "react"

interface FirstMiddleStepProps {
    onPreviousStep: () => void
    onNextStep: () => void
    inputText:string
    setInputText: React.Dispatch<React.SetStateAction<string>>
    investmentInputStartLabel: string
    investmentInputStartPlaceholder: string
    startInvestmentTabs: StartInvestmentTab[]
    firstMiddleStepNumber: string
    firstMiddleStepHeading: string
    firstMiddleStepDescription: string
    middleStepPreviousButtonLabel: string
    middleStepNextButtonLabel: string
    sharedClasses: {
        stepContainer: string
        buttonContainer: string
        textContainer: string
        description: string
    }
    currency: string
}
export default function FirstMiddleStep({
    onNextStep,
    inputText,
    setInputText,
    investmentInputStartLabel,
    investmentInputStartPlaceholder,
    startInvestmentTabs,
    firstMiddleStepNumber,
    firstMiddleStepHeading,
    firstMiddleStepDescription,
    middleStepNextButtonLabel,
    sharedClasses,
    currency,
}: FirstMiddleStepProps) {

    const [inputWarning, setInputWarning] = useState(false)

    function handleCheckInputValue() {
        if (inputText) {
            onNextStep()
            setInputWarning(false)
        }
        else {
            setInputWarning(true)
        }
    }

    React.useEffect(() => {
        if (inputWarning && inputText !== "") setInputWarning(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputText])

    return (
        <div className={sharedClasses.stepContainer}>
            <div className={sharedClasses.textContainer}>
                <p className="label-200">{firstMiddleStepNumber}</p>
                <Heading className="heading-300">
                    {firstMiddleStepHeading}
                </Heading>
                <p className={cn(sharedClasses.description, "paragraph-100")}>{firstMiddleStepDescription}</p>
            </div>
            <InvestmentInput
                label={investmentInputStartLabel}
                currency={currency}
                placeholder={investmentInputStartPlaceholder}
                inputText={inputText}
                setInputText={setInputText}
                inputWarning={inputWarning}
                setInputWarning={setInputWarning}
            />
            <div className={s["investment-tabs__list-container"]}>
                <ul className={s["investment-tabs__list"]}>
                    {startInvestmentTabs.map(tab => <InvestmentTab key={tab.id} moneyAmount={tab.moneyAmount} currency={tab.tabCurrency} setInputText={setInputText} />)}
                </ul>
            </div>

            <div className={cn(s["button-container"], sharedClasses.buttonContainer)}>
                <Button pill onClick={handleCheckInputValue}>
                    {middleStepNextButtonLabel}
                </Button>
            </div>
        </div>
    )
}
